import { createTheme } from '@mui/material/styles';
export const getMuiTheme = (mode = 'light') => createTheme({ palette: {mode}});